import { UserListItem } from "common/ListItems";
import * as favoritesActions from "lib/api/favorites";
import { connect } from "react-redux";

const mapDispatchToProps = (dispatch) => {
  return {
    pin: (id) => dispatch(favoritesActions.pin("user", id)),
    unpin: (id) => dispatch(favoritesActions.unpin("user", id)),
  };
};

const mapStateToProps = (state, ownProps) => {
  const favorites = state.favorites;

  return {
    pinned: !!favorites.getIn(["favoritesByType", "user", ownProps.user.get("id")]),
  };
};

export const UserListItemContainer = connect(mapStateToProps, mapDispatchToProps)(UserListItem);
